import { CONFIG } from '../config/config'

export const totalWeeks   = (years = CONFIG.DEFAULT_LIFESPAN) =>
  Math.round(years * CONFIG.WEEKS_PER_YEAR)

export const weeksLived   = (dob) => {
  if (!dob) return 0
  const ms = Date.now() - new Date(dob).getTime()
  return Math.max(0, Math.floor(ms / 604800000))  // 604800000 = 7 days in ms
}

export const weeksLeft    = (dob, lifespan) =>
  Math.max(0, totalWeeks(lifespan) - weeksLived(dob))

export const lifePercent  = (dob, lifespan) => {
  const t = totalWeeks(lifespan)
  return t ? Math.min(100, (weeksLived(dob) / t) * 100) : 0
}

export const currentAge   = (dob) => {
  if (!dob) return 0
  const d   = new Date(dob)
  const now = new Date()
  let age   = now.getFullYear() - d.getFullYear()
  if (now.getMonth() < d.getMonth() || (now.getMonth() === d.getMonth() && now.getDate() < d.getDate())) age--
  return Math.max(0, age)
}

export const allocatedWeeks = (goals) =>
  goals
    .filter(g => ['committed', 'active', 'paused'].includes(g.status))
    .reduce((s, g) => s + (g.estimated_weeks ?? 0), 0)

// Human-friendly duration
export const fmtWeeks = (w) => {
  if (!w && w !== 0) return '—'
  if (w < 4)  return `${w}w`
  if (w < 52) return `${(w / 4).toFixed(0)}mo`
  return `${(w / 52).toFixed(1)}yr`
}

export const fmtYearsMo = (w) => {
  if (!w) return '—'
  const y  = Math.floor(w / 52)
  const mo = Math.floor((w % 52) / 4)
  if (y > 0 && mo > 0) return `${y}y ${mo}mo`
  if (y > 0) return `${y}y`
  return `${mo}mo`
}
